/**
 * Sends successful distributor PIN usage events to a Google Apps Script web app.
 *
 * The configured Apps Script should append `values` to the tab named by
 * `sheetName`. Keeping this endpoint separate from the autofill tracker allows
 * the PIN audit log to be routed to its own spreadsheet tab.
 */
const getWebAppUrl = () =>
  process.env.REACT_APP_PIN_USAGE_SHEET_WEB_APP_URL?.trim();

const getSheetName = () =>
  process.env.REACT_APP_PIN_USAGE_SHEET_TAB?.trim() || "PIN Usage Log";

export async function logPinMarkedAsUsed({
  distributorName,
  agentName,
  pinId,
  pin,
}) {
  const webAppUrl = getWebAppUrl();

  if (!webAppUrl) {
    console.warn(
      "PIN usage was not logged to Google Sheets because REACT_APP_PIN_USAGE_SHEET_WEB_APP_URL is not configured."
    );
    return { success: false, skipped: true };
  }

  const values = [
    new Date().toISOString(),
    distributorName || "",
    agentName || "",
    pinId ?? "",
    pin || "",
  ];

  try {
    // Google Apps Script web apps commonly require no-cors requests. This
    // means the browser cannot inspect its response, so this only reports
    // whether the request was dispatched successfully.
    await fetch(webAppUrl, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify({ sheetName: getSheetName(), values }),
    });

    return { success: true };
  } catch (error) {
    console.error("Failed to log PIN usage to Google Sheets:", error);
    return { success: false, error };
  }
}
